const DEFAULT_SORT_KEY = 'display_name';
const DEFAULT_ASCENDING = true;

export interface TpSortOptions {
  id: string;
  title: string;
  type: string;
  assetInfoKey: string;
  reverse?: boolean;
}

/**
 * Determine the default sort option, sort key and ascending/descending order from the dashboard template.
 * Fallback to the first sort option if the sort key was not found.
 * Fallback to Global defaults if anything goes wrong.
 * @param dashboardtemplate
 */
export function getDefaultSortOption(dashboardtemplate: any): [string, boolean] {
  try {
    const assetOverview = dashboardtemplate.startPageElements.find((element: any) => element.type === 'assetOverview');
    const sortOptions: TpSortOptions[] = assetOverview?.sortOptions || [];
    const defaultSortId: string = assetOverview?.sortBy || '';

    if (!sortOptions || sortOptions.length === 0) {
      return [DEFAULT_SORT_KEY, DEFAULT_ASCENDING];
    }
    const sortOption = sortOptions.find((option) => option.id === defaultSortId) ?? sortOptions[0];
    return [sortOption.assetInfoKey || DEFAULT_SORT_KEY, !sortOption.reverse];
  } catch (error) {
    return [DEFAULT_SORT_KEY, DEFAULT_ASCENDING];
  }
}

/**
 * Get the default limit for asset overview from the start page template
 * @param startPageTemplate The start page template object
 * @returns The default limit for asset overview
 */
export function getDefaultLimit(startPageTemplate: any): number {
  const assetOverview = startPageTemplate?.startPageElements?.find((element: any) => element.type === 'assetOverview');
  return assetOverview?.limit || import.meta.env.VITE_DEFAULT_LIMIT;
}
